import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
import css from "./card-class.module.scss";
import classNames from "classnames";
import { IconChevronDown, IconClassroom, IconDownload } from "Icons";
import { CardContent, Button , JustifyBetween} from "components";
import { withUserContext } from "context";



class CardClass extends PureComponent {
  render() {
    
    return (
      <CardContent
        {...this.props}
        className={classNames(css.card, this.props.isExpanded && css.expanded)}
      >
        <CardContent.Top size="sm" icon={<IconClassroom />}></CardContent.Top>
        <Card.Body>
          <Card.Title>
            {this.props.title}
            <div>
              <IconChevronDown
                className="fill-primary mr-2"
                width="15px"
                height="15px"
              />
              {this.props.ctx_user.user.reportsTrainer && (
                <Button
                  iconOnly
                  variant="white"
                  size="sm"
                  pill
                  className="px-2"
                  onClick={(e) =>
                    this.props.onDownloadClick(e, this.props.data[0].id)
                  }
                >
                  <IconDownload className="DwnloadIcon" />
                </Button>
              )}
            </div>
          </Card.Title>
        </Card.Body>

        <div className={css.arrow}></div>
      </CardContent>
    );
  };
};


CardClass.propTypes = {
  title: PropTypes.string,
  isExpanded: PropTypes.bool
};

CardClass.defaultProps = {
  title: "",
  isExpanded: false
}

export default withUserContext(CardClass);
